module.exports = __webpack_public_path__ + "img/1451969113.7409857a.jpg";